module.exports = __webpack_public_path__ + "img/异常登记.f3645d57.svg";